export const GET_ZONES_LIST = "GET_ZONES_LIST";
export const GET_SHIFTS_LIST = "GET_SHIFTS_LIST";
export const GET_SHIFT = "GET_SHIFT";
export const GET_MAINTANANCE_CATEGORIES = "GET_MAINTANANCE_CATEGORIES";
export const GET_SP_TECHNICIANS = "GET_SP_TECHNICIANS";
export const GET_OPERATING_HOURS = "GET_OPERATING_HOURS";